<template>
    <div class="floor-plan-icons">
        <a
            v-for="(icon,index) in floorPlan.ico"
            v-show="icon.url"
            :key="index"
            class="img-floor-plan-gallery-image"
            @click="openImage(icon)"
        >
            <img
                class="floor-plan-icon"                   
                :src="'/img/icons/cam/cam_'+ icon.orientation +'.svg'"
                :style="{
                    width: icon.width + 'px',
                    height: icon.height + 'px',
                    left: icon.x + 'px',
                    top: icon.y + 'px',
                }" 
            />
        </a>
    </div>
</template>

<script>
export default {
    props: {
        floorPlan: {
            type: Object,
            required: true,
        },
    },

    mounted() {

    },

    methods: {
        openImage(icon) {
            let url = icon.url
            if (icon.orientation == 'vt') {
                console.log(url)
                window.events.$emit('showModal', { 
                    name: 'plan-virtualtour', 
                    data: { url } 
                })
            } else {
                window.events.$emit('showModal', { 
                    name: 'plan-gallery', 
                    data: { url } 
                })
            }
        },
    },
}
</script>

<style lang="sass" scoped>
    .floor-plan-icons
        display: block
        position: absolute
        top: 0
        width: 100%

        .floor-plan-icon
            position: absolute
            transform: scale(1.4)
            border-radius: 50%
            background: #ffffff30
            cursor: pointer
</style>